module.exports = __webpack_public_path__ + "jiantou.63b5342e.svg";